import { ContactType } from './portfolio.types';

export const PORTFOLIO_MODULE_FORM_KEYS: string[] = [
  'PORTFOLIO_MODULE_FORMKEY',
  'PORTFOLIO_DETAIL_FORMKEY',
];

const contactTypes = [
  'Buyer',
  'Customer',
  'WHBuyer',
  'SystemVendor',
  'Supplier',
  'Sourcing',
] as const;

export const contactTypeList: ContactType[] = contactTypes.map((type): ContactType => ({
  id: type,
  name: type,
  value: type,
}));
